import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=ce411a1a&scoped=true&"
import script from "./Stage.vue?vue&type=script&lang=js&"
export * from "./Stage.vue?vue&type=script&lang=js&"
import style0 from "./Stage.vue?vue&type=style&index=0&id=ce411a1a&lang=scss&scoped=true&"
import style1 from "./Stage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce411a1a",
  null
  
)

export default component.exports